module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/controls.gif?244e8600e6ae5d4e6e7744b258289032";